import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'
import {
  invalidateManagersCache,
  searchEntitySuggestions as searchWithRequest,
} from './entitySmartSearchClient.mjs'

export { invalidateManagersCache }

function defaultApiGet(path, params, { signal } = {}) {
  const api = useAxiosCreate('api')
  return api
    .get(path, {
      params,
      signal,
      headers: authHeader(),
    })
    .then((res) => res.data)
}

/**
 * Умный поиск сущностей для формы создания исполнителя.
 * companies / drivers / cars / trailers → GET /api/v2/{model}/list?search=
 * managers → GET /api/v2/wizard-search?model=managers[&company_id=]
 */
export async function searchEntitySuggestions(model, query, options = {}) {
  const { signal, request = defaultApiGet, companyId } = options
  return searchWithRequest(model, query, { signal, request, companyId })
}
